var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.00004C10.5304 6.00004 11.0391 5.78933 11.4142 5.41425C11.7893 5.03918 12 4.53047 12 4.00004C12 3.46961 11.7893 2.9609 11.4142 2.58583C11.0391 2.21075 10.5304 2.00004 10 2.00004M12 9.33337C13.1693 9.59004 14 10.2394 14 11C14 11.6867 13.324 12.282 12.3333 12.58M8.66666 4.00004C8.66666 5.4728 7.47275 6.66671 6 6.66671C4.52724 6.66671 3.33333 5.4728 3.33333 4.00004C3.33333 2.52728 4.52724 1.33337 6 1.33337C7.47275 1.33337 8.66666 2.52728 8.66666 4.00004ZM10.6667 11.3334C10.6667 12.8061 8.57732 14 6 14C3.42267 14 1.33333 12.8061 1.33333 11.3334C1.33333 9.86062 3.42267 8.66671 6 8.66671C8.57732 8.66671 10.6667 9.86062 10.6667 11.3334Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.41a4fe15f1c0836dea2bd35ccb5bcffc.svg";
export { ForwardRef as ReactComponent };